<template>
    <section class="chart-container">
        <!--工具条-->
		<el-col :span="24" class="toolbar" style="padding-bottom: 0px;">
			<el-form :inline="true" :model="filters"  size="mini">
                <el-form-item label="项目">
					<el-select v-model="filters.projectId"     @change="getDevices" style="width:250px" filterable>
						<el-option
							v-for="item in projects"
							:label="item.name"
							:value="item.projectId" :key="item.projectId">
						</el-option >
					</el-select>
				</el-form-item>
                <el-form-item label="点位名称" >
					<el-select v-model="filters.mn"   style="width:320px" filterable reserve-keyword>
						<el-option
							v-for="item in devices"
							:label="item.name"
							:value="item.mnCode" :key="item.mnCode">
						</el-option>
					</el-select>
				</el-form-item>
                <el-form-item label="设备编码"  v-if="type==0">
					<el-select v-model="filters.mn"  style="width:320px" filterable reserve-keyword>
						<el-option
							v-for="item in devices"
							:label="item.mnCode"
							:value="item.mnCode" :key="item.mnCode">
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item>
					<my-button  @select-type="clickBtn" QueryButtonShow SettingButtonShow btnCon="去审核"></my-button>
				</el-form-item>
			</el-form>
		</el-col>

        <!-- 折线图 -->
        <el-col :span="24"   v-loading="listLoading" style="overflow: hidden;">
            <el-calendar v-model="calendarvalue" class="calendar_left">
                <template  slot="dateCell"  slot-scope="{date, data}" >
                    <div class="Userdate"   v-if="realDatas.get (data.day)!=undefined" @click="chooseDate(data.day)">
                        <div  class="ueds_iedn"  :style="'border:4px solid '+realDatas.get (data.day)">{{ data.day.split('-')[2]}}</div>
                    </div>
                    <div class="Userdate"   v-else @click="chooseDate(data.day)">
                        <div  class="ueds_iedn"  style="border:none">{{ data.day.split('-')[2]}}</div>
                    </div>
                </template>
            </el-calendar>
            <div  class="calendar_right">
                <div class="cal_date">{{ date }}</div>
                <div class="cal_day">{{ num }}</div>
                <div>
                    <div v-for=" item in levelList" style="display: flex;margin-left: 20%;align-items: center;margin-top: 20px;">
                        <div  class="uenf_l" :style="'border:4px solid '+item.color"></div>
                        <span :style="'color:'+item.color">{{item.remark}}</span>
                    </div>
                </div>
            </div>
        </el-col>

    </section>
</template>

<script>
    import {getProjects,getDevicesByProjectId,selectNoiseCalendar} from '../../api/api';

    import {formatDateDay,formatDate} from '../../../static/fun.js';

    import myButton from '../../components/myButton/index.vue'

    export default {
    components: { myButton },
        data() {
            return {
                filters: {
                    mn: '',
                    projectId:''
                },
                calendarvalue:'',
                projects:[],
                devices:[],
                realDatas:new Map(),
                listLoading:false,
                firstFlag:true,
                formHeight:0,
                dataType:'n00004',
                type:sessionStorage.getItem("type"),
                date:'',
                num:'',
                levelList:[
                    {id:1,remark:'未审核',limit:0,color:'#3e6eff'},
                    {id:4,remark:'通过',limit:1,color:'green'},
                    {id:5,remark:'异常',limit:2,color:'red'}
                ]
            }
        },
        created(){
            this.$nextTick(() => {
                // 点击上个月
                let prevBtn = document.querySelector('.el-calendar__button-group .el-button-group>button:nth-child(1)');
                prevBtn.addEventListener('click', () => {
                    this.calendarvalue=formatDateDay(this.calendarvalue);
                    this.date=this.calendarvalue;
                    this.num=this.date.split('-')[2];
                    this.getDataList();
                })
                // 点击今天
                let currBtn = document.querySelector('.el-calendar__button-group .el-button-group>button:nth-child(2)');
                currBtn.addEventListener('click', () => {
                    this.calendarvalue=formatDateDay(this.calendarvalue);
                    this.date=this.calendarvalue;
                    this.num=this.date.split('-')[2];
                    this.getDataList();
                })
                // 点击下个月
                let nextBtn = document.querySelector('.el-calendar__button-group .el-button-group>button:nth-child(3)');
                nextBtn.addEventListener('click', () => {
                    this.calendarvalue=formatDateDay(this.calendarvalue);
                    this.date=this.calendarvalue;
                    this.num=this.date.split('-')[2];
                    this.getDataList();
                })
            })
        },
        methods: {
            clickBtn(type){
				if(type=="query"){
					this.getDataList();
				}else if(type=="setting"){
                    //跳转到审核界面
                    this.$router.push({ path: '/reviewDataMa',query:{mn:this.filters.mn,projectId:this.filters.projectId,time:this.date} });
                }
			},
            chooseDate(data){
                this.date=data;
                this.num=data.split('-')[2];
            },
            //查询项目信息
			getProjects() {
				this.listLoading = true;
				getProjects().then((res) => {
                    this.projects = res.data.data;
                    this.listLoading = false;
                    
			        if(this.projects.length>0){
                         this.filters.projectId=this.projects[0].projectId;
						this.getDevices();
					}
				});
			},
            //获取趋势分析数据
            getDataList(){
                this.calendarvalue=formatDate(this.calendarvalue);
                var arr=this.calendarvalue.split('-');
                var starttime=arr[0]+"-"+arr[1];

                let para = {
                    mn: this.filters.mn,
                    date: starttime
                };
                this.listLoading = true;
                //数据格式处理
				selectNoiseCalendar(para).then((res) => {
                    this.listLoading = false;
                    if(res.data.result==true||res.data.result=="true"){
                        var datas = res.data.datas;
                        let keys = Object.keys(datas);

                        this.realDatas=new Map();
                        for (let index = 0; index < keys.length; index++) {
                            const element = keys[index];
                            var value=datas[element];
                            if(value!=null){
                                var isValid=value.isValid; 
                                var color="red";
                                //判断颜色
                                for (let j = 0; j < this.levelList.length; j++) {
                                    var limit = this.levelList[j].limit;
                                    if(isValid==limit){
                                        color=this.levelList[j].color;
                                        break;
                                    }
                                }
                                this.realDatas.set(element,color);
                            }
                        }
                    }else{
                        this.$message({
                            message: "查询出错,请重试",
                            type: 'warn'
                        })
                        return;
                    }
				});
            },
            //获取设备列表
			getDevices() {
                 if(this.filters.projectId.toString()==""){
                    return;
                }
                this.listLoading = true;
                let para = {
                    projectId: this.filters.projectId.toString()
                };
				getDevicesByProjectId(para).then((res) => {
                    this.listLoading = false;
                    
                    this.devices = res.data.data;
                    if(this.devices.length>0){
                        this.filters.mn=this.devices[0].mnCode;
                        if(this.firstFlag){
                            this.getDataList();
                            this.firstFlag=false;
                        }
					}

				});
            }
        },
        mounted: function () {
            this.calendarvalue=new Date();
            this.calendarvalue=formatDateDay(this.calendarvalue);
            this.date=this.calendarvalue;
            this.num=this.calendarvalue.split('-')[2];
            this.getProjects();
        }
    }
</script>

<style scoped>
    .el-col-1{
        text-align: center;
    }
    .dataTab{
		margin: 10px;
		margin-top: 0;
		cursor: pointer;
		color: #409eff;
		background: #d9edf7;
	}
    .tabSelect{
		color: #fff;
		background: #409eff;
	}

    .calendar_left{
        width: 60%;
        margin-left: 5%;
        float:left;
    }
    .calendar_right{
        width: 20%;
        float:left;
        padding-bottom: 2%;
        margin-top: 6vh;
        background: #6cd3fb;
        margin-left: 3%;
    }

    .cal_date {
        color: #fff;
        font-size: 24px;
        padding-top: 10px;
        margin-left: 10px;
        font-weight: bold;
    }
    .cal_day {
        margin: 20px auto;
        width: 60%;
        height: 100px;
        background: #fb0;
        -webkit-box-pack: center;
        -ms-flex-pack: center;
        justify-content: center;
        color: #fff;
        font-size: 40px;
        align-items: center;
        display: flex;
    }

    .uenf_l {
        width: 50px;
        height: 50px;
        background: #6cd3fb;
        border-radius: 50%;
        margin-right: 20px;
    }


    .Userdate {
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-align: center;
        -ms-flex-align: center;
        align-items: center;
        -webkit-box-pack: center;
        -ms-flex-pack: center;
        justify-content: center;
        height: 100%;
    }
    .ueds_iedn{
        width: 50px;
        height: 50px;
        border-radius: 50%;
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-align: center;
        -ms-flex-align: center;
        align-items: center;
        -webkit-box-pack: center;
        -ms-flex-pack: center;
        justify-content: center;
    }
</style>



// WEBPACK FOOTER //
// ReviewCalendar.vue?ae8d10c8